(function () {
  function initCustomCursor(root) {
    const containers = (root || document).querySelectorAll('.home-top-selector-section-inner');

    containers.forEach(function (container) {
      // Nur wenn der Cursor fuer diese Section aktiviert ist.
      if (container.dataset.cursorEnabled !== 'true') return;

      // Doppel-Initialisierung verhindern (Theme Editor, mehrfaches Laden).
      if (container.dataset.cursorInitialized === 'true') return;

      const cursorTitle = container.dataset.cursorTitle;
      const cursorColor = container.dataset.cursorColor || '#FFFBBE';

      // Ohne Text macht der Cursor keinen Sinn.
      if (!cursorTitle || cursorTitle === 'undefined') return;

      container.dataset.cursorInitialized = 'true';

      const customCursor = document.createElement('div');
      customCursor.classList.add('custom-cursor');
      container.appendChild(customCursor);

      const customCursorText = document.createElement('div');
      customCursorText.classList.add('custom-cursor-text');
      customCursorText.classList.add('maus');
      customCursorText.innerHTML = cursorTitle;
      customCursor.appendChild(customCursorText);

      customCursor.style.opacity = 0;
      customCursorText.style.opacity = 0;
      customCursorText.style.color = cursorColor;
      customCursor.style.backgroundColor = cursorColor;

      container.addEventListener('mousemove', function (e) {
        if (
          e.target.closest('.home-top-selector-section__selectors') ||
          e.target.closest('.cursor-disabled-bd')
        ) {
          customCursor.style.opacity = 0;
          customCursorText.style.opacity = 0;
          return;
        }

        const containerRect = container.getBoundingClientRect();
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        customCursor.style.left = mouseX + 'px';
        customCursor.style.top = mouseY + 'px';

        const offsetX = 15;
        const distanceFromRightEdge = containerRect.right - mouseX;
        const estimatedTextWidth = customCursorText.offsetWidth || 80;
        const tooCloseToRight = distanceFromRightEdge < estimatedTextWidth + offsetX + 15;

        const distanceFromBottomEdge = containerRect.bottom - mouseY;
        const tooCloseToBottom = distanceFromBottomEdge < 30;

        if (tooCloseToRight) {
          customCursorText.style.right = '15px';
          customCursorText.style.left = 'auto';
        } else {
          customCursorText.style.left = offsetX + 'px';
          customCursorText.style.right = 'auto';
        }

        customCursorText.style.top = tooCloseToBottom ? '-20px' : '-3px';

        customCursor.style.opacity = 1;
        customCursorText.style.opacity = 1;
      });

      container.addEventListener('mouseleave', function () {
        customCursor.style.opacity = 0;
        customCursorText.style.opacity = 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomCursor(document);
    });
  } else {
    initCustomCursor(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCustomCursor(event.target);
  });
})();